import AccountDetails from './AccountDetails'
export default AccountDetails


// WEBPACK FOOTER //
// ./src/components/AccountDetails/index.js